import React, {useEffect, useState} from "react";
import usePaymentService from "../../api/services/usePaymentService";
import Loading from "../../components/Loading/Loading";
import Button from "../../components/Button/Button";
import PaymentRow from "../../components/PaymentRow/PaymentRow";
import {useParams} from "react-router-dom";

const UserPayments = () => {

  const {userShow} = usePaymentService()
  const [payments, setPayments] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const {bookingId} = useParams()

  useEffect(() => {
    userShow(
      (payments) => {
        setPayments(payments)
        setIsLoading(false)
      },
      () => {

      },
      bookingId
    )
  }, [])

  return (
    <div className="page-user-payments">
      <h1>Betalingen {bookingId && ' voor boeking'}</h1>
      <div className="row buttons">
        {bookingId ?
          <Button
            label="Terug naar boeking"
            link={'/user/boeking/' + bookingId}
          />
          :
          <>
            <Button
              label="Boekingsoverzicht"
              link={'/user/boekingen'}
            />
            <Button
              label="Uitbetalingen"
              link={'/user/bonnen'}
            />
          </>
        }

      </div>

      {isLoading ?
        <Loading/>
        :
        <div className="payments">
          {payments && !!payments.length
            ? payments.map((payment, i) => {
              return (<PaymentRow key={i} payment={payment} showLinksToBooking={!bookingId}/>)
            })
            : <p>Nog geen betalingen</p>
          }
        </div>
      }
    </div>
  )
}

export default UserPayments
